/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { SUPPORT_EMAIL } from "../../lib/common/constants";

export type TWelcomeTechProps = {
    techName: string;
};
export const WelcomeModal = ({ techName }: TWelcomeTechProps) => {
    const refWelcomeModal = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;
    const handleWelcomeModalClose = () => {
        if (!refWelcomeModal.current) {
            setTimeout(() => {
                handleWelcomeModalClose();
            }, 100);
            return;
        }
        if (windowGlobal.wwg_refWelcomeModal) {
            //TODO: change to window.bootstrap.Modal.getInstance(refWelcomeModal.current)?.hide(); when we update to bootstrap 5.2
            windowGlobal.wwg_refWelcomeModal.hide();
        }
    };

    useEffect(() => {
        if (!refWelcomeModal.current) return;

        windowGlobal.wwg_refWelcomeModal = new window.bootstrap.Modal(
            refWelcomeModal.current
        );

        windowGlobal.wwg_refWelcomeModal.show();

        return () => {
            if (windowGlobal.wwg_refWelcomeModal) {
                windowGlobal.wwg_refWelcomeModal.hide();
            }
        };
    }, []);

    return (
        <div className="modal fade" tabIndex={-1} ref={refWelcomeModal}>
            <div className="modal-dialog modal-dialog-centered ">
                <div className="modal-content bg-dark text-white rounded p-3">
                    <div className="modal-header justify-content-center border-0">
                        <h1 className="modal-title text-center">
                            Welcome Aboard <br />
                            <span className="highlighted-title text-uppercase">
                                {techName}
                            </span>
                            {""} !
                        </h1>
                        {/* <button type="button" className="btn-close btn-close-white border border-light border-3" data-dismiss="modal" aria-label="Close"></button> */}
                    </div>
                    <div className="modal-body text-center border-0">
                        <h4>Let’s start your next chapter!</h4>
                        <br />
                        <h5 className="lh-base px-4">
                            {" "}
                            Complete your profile to get the most out of our
                            platform. This will help us match you with the best
                            dental employers!
                        </h5>
                    </div>
                    <div className="modal-footer border-0">
                        <button
                            type="button"
                            className="btn btn-primary w-100 fw-bold"
                            // data-bs-dismiss="modal"
                            onClick={handleWelcomeModalClose}
                        >
                            LET'S GO!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export type TWelcomeLabProps = {
    labName: string;
};
export const WelcomeLabModal = ({ labName }: TWelcomeLabProps) => {
    const refWelcomeLabModal = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;
    const handleWelcomeLabModalClose = () => {
        if (!refWelcomeLabModal.current) {
            setTimeout(() => {
                handleWelcomeLabModalClose();
            }, 100);
            return;
        }
        if (windowGlobal.wwg_refWelcomeLabModal) {
            //TODO: change to window.bootstrap.Modal.getInstance(refWelcomeLabModal.current)?.hide(); when we update to bootstrap 5.2
            windowGlobal.wwg_refWelcomeLabModal.hide();
        }
    };

    useEffect(() => {
        if (!refWelcomeLabModal.current) return;

        windowGlobal.wwg_refWelcomeLabModal = new window.bootstrap.Modal(
            refWelcomeLabModal.current
        );

        windowGlobal.wwg_refWelcomeLabModal.show();

        return () => {
            if (windowGlobal.wwg_refWelcomeLabModal) {
                windowGlobal.wwg_refWelcomeLabModal.hide();
            }
        };
    }, []);

    return (
        <div className="modal fade" tabIndex={-1} ref={refWelcomeLabModal}>
            <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
                <div className="modal-content bg-dark text-white p-3 text-center">
                    <div className="modal-header justify-content-center border-0">
                        <h2 className="modal-title text-center">
                            Welcome to WinWinGo!
                            <br />
                        </h2>
                    </div>
                    <div className="modal-body">
                        <h1 className="highlighted-title text-uppercase">
                            {labName}
                        </h1>
                        <p className="lh-base">
                            Take a moment to personalize your profile and start
                            connecting with top dental talent.
                            <br />
                        </p>
                        <p className="mt-3 lh-base">
                            If you spot an issue or have ideas for improvement,
                            we’d love to hear from you at{" "}
                            <a
                                className="btn-link text-primary"
                                href={"mailto:" + SUPPORT_EMAIL}
                            >
                                {" "}
                                {SUPPORT_EMAIL}
                            </a>
                            .
                            <br /> <br />
                            Your feedback helps us build the best dental
                            employment platform on the web!
                        </p>
                        <div className="mt-5">
                            <button
                                type="button"
                                className="btn btn-primary w-100 fw-bold"
                                // data-bs-dismiss="modal"
                                onClick={handleWelcomeLabModalClose}
                            >
                                Go to My Profile
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
